export default __webpack_public_path__ + "static/left_bg-705a6bbd82f09f03fe751e67b4fcff53.svg";